import { render, staticRenderFns } from "./JSearchSelectTag.vue?vue&type=template&id=e55120e6&scoped=true"
import script from "./JSearchSelectTag.vue?vue&type=script&lang=js"
export * from "./JSearchSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55120e6",
  null
  
)

export default component.exports